<template lang='pug'>
  v-dialog(v-model="dialogPermit" id="modal" transition="dialog-bottom-transition" width="30%" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-snackbar(
        v-model="snackbar"
        :timeout="10000"
        color='error'
    ) {{ snackbarMessage }}
    ModalNotif(:openModalNotif="openModalNotif" @closeModal="openModalNotif = false")
    template(v-if="imId == 'menu'" v-slot:activator="{ on }")
      v-list-item(active-class='secondary--text'  v-on:click="toClear" @click="cekValidate()")
        v-list-item-action
            v-icon library_add
        v-list-item-content
            v-list-item-title Create New
    template(v-else v-slot:activator="{ on }")
      v-btn(class="text-xs-center" color="primary" fab small  v-on:click="toClear"  @click="cekValidate()")
          v-icon add
    v-dialog(v-model="dialogPermit" width="30%")
      v-card()
        v-card-title(class="headline grey lighten-2" primary-title) Pilih Jenis Form
        v-card-text
          v-container
            v-row
              v-autocomplete(
                v-model="listPermit"
                label="Jenis Form"
                :items="jenisIzin"
                item-text="name"
                item-value="data"
                return-object=true
                v-on:change="toRoute"
                clearable
                chips)
        v-card-actions(v-if="$vuetify.breakpoint.xsOnly")
          v-spacer
          v-btn(color="blue darken-1", text, @click="dialogPermit = false") Close
</template>

<script>
import * as config from "../config/index.json";
import { mapState } from "vuex";
import store from '../store';
import ModalNotif from "./ModalNotif.vue";
import { handleError } from '../helper/handleGlobalError.js';
import axios from 'axios';
  export default {
    name: 'PermitModal',
    components: {
      ModalNotif
    },
    props: {
      imId: String
    },
    data: () => ({
      config: config.default,
      jenisIzin: [],
      dialogPermit: false,
      listPermit: '',
      openModalNotif : false,
      snackbar: false,
      snackbarMessage: ''
    }),
    mounted () {
      this.jenisIzin = config.jenisIzin.reduce((acc, i) => {
        if (i.code !== 'BIB-HSE-PPO-F-071-01') acc.push(i);
        return acc;
      }, []);
    },
    computed: {
      ...mapState(["API_URL","openModalNot"]),
    },
    methods: {
      toRoute(data) {
        this.dialogPermit = false;
        this.$router.push(data.route);
      },
      toClear(){
        this.listPermit = 0;
      },
      cekValidate(){
      this.dialogPermit = true;  
      const d = new Date();
      const config = {
          method: "get",
          url: `${store.state.API_URL}/isSessionExpired/${store.state.token}?dt=${d.getTime()}`
      };
        axios(config).then(res => {
            if (res.status == 200) {
              setTimeout(() => {
                if(res.data.appVersion !== localStorage.getItem('appVersion')){
                  this.dialogPermit = false;
                  this.openModalNotif = true
              }
              },700)
            }
        }).catch(error => {
            handleError(error, {
                setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
                showSnackbar: (show) => { this.snackbar = show; },
                disableLoader: () => { 
                    this.$store.state.loader = false;
                },
            });
        });

      }
    },
    watch: {
    }
  };


</script>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
</style>

    